/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
export { Sender } from "./Sender";
//# sourceMappingURL=applicationinsights-channel-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-channel-js/dist-esm/applicationinsights-channel-js.js
// module id = 114
// module chunks = 37